import axios from 'api/axios'
import { useCallback, useState } from 'react'

/**
 * Hook para buscar pedidos por rango de fechas
 * @param {Object} props - Parámetros del hook
 * @param {number} props.idPlanificacion - ID de la planificación
 * @returns {Object} { response, loading, error, fetchPedidos }
 */

const useFetchPedidosPorRango = ({ idPlanificacion }) => {
  const [response, setResponse] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchPedidos = useCallback(
    (fechaDesde, fechaHasta) => {
      setLoading(true)
      setError(null)

      // Construir query params
      const params = new URLSearchParams()
      params.append('planificacion_seleccionada', idPlanificacion)

      const url = `/optprod/adm/pedidos/?${params.toString()}`

      axios
        .get(url)
        .then((request_response) => {
          const data = request_response.data

          // Filtrar por rango de fechas localmente
          let pedidosFiltrados = data

          if (fechaDesde || fechaHasta) {
            pedidosFiltrados = data.filter((pedido) => {
              if (!pedido.fecha_entrega) return false

              const fechaPedido = new Date(pedido.fecha_entrega)
              const desde = fechaDesde ? new Date(fechaDesde) : null
              const hasta = fechaHasta ? new Date(fechaHasta) : null

              if (desde && fechaPedido < desde) return false
              if (hasta && fechaPedido > hasta) return false

              return true
            })
          }

          setResponse(pedidosFiltrados)
        })
        .catch((err) => setError(err.message))
        .finally(() => setLoading(false))
    },
    [idPlanificacion],
  )

  const reset = useCallback(() => {
    setResponse([])
    setLoading(false)
    setError(null)
  }, [])

  return { response, loading, error, fetchPedidos, reset }
}

export default useFetchPedidosPorRango
